module.exports = __webpack_public_path__ + "img/icon_jianceshi@2x.191915d8.png";